



























import { Component, Vue, Watch } from "vue-property-decorator";
import CompanyPage from "@/components/companies/CompanyPageInfo.vue";
import api from "@/getinfo-api";
import { Company as ICompany } from "@/api/models/company";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { getCurrentUserId, isRoot } from "@/plugins/roles";
import WidgetCreate from "@/components/integrations/WidgetForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: { CBreadCrumbs, WidgetCreate, CompanyPage }
})
export default class CompanyPageView extends Vue {
  companyInfo?: ICompany | string | undefined | any;
  data() {
    return {
      companyInfo: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "companies" },
        label: `${this.$tc(this.$translate.Companies)}`
      },
      {
        label: this.$converter.limitedOutput(this.companyInfo?.title, 40)
      }
    ];
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return this.userId === this.companyInfo?.owner.id;
  }

  getCompanyInfo() {
    api.CompanyApi.get(this.$route.params.id)
      .then((res: { data: ICompany }) => {
        this.companyInfo = res.data;
        document.title = this.companyInfo.title;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  created() {
    this.getCompanyInfo();
  }

  @Watch("$route")
  updCompany() {
    this.companyInfo = undefined;
    this.getCompanyInfo();
  }
}
